<div class="container ps-4 ps-lg-2">
  <h1 translate>NAVBAR.TRAININGS.ALL</h1>
</div>
<div class="container d-flex flex-wrap justify-content-center justify-content-lg-start">
  @for (training of (sortedTrainings$ | async); track trackTraining($index, training)) {
    <!-- exclude trainings without content to not mess up the layout -->
    @if (training.has_content) {
      <app-training-card class="card" [training]="training"></app-training-card>
    }
  }
</div>
